(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurora-mystery-scoops-landing"] && !Shopify.designMode) return;
  try {
    

(() => {

  const normalize = (value) =>
    value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();


  document
    .querySelectorAll('[data-aurora-mystery]')
    .forEach((root) => {

      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';


      /* ======================================================
         CARROSSEL SNAP GENÉRICO
         ====================================================== */

      const createSnapCarousel = ({
        track,
        slides,
        prev,
        next,
        dotsWrap,
        autoplay = 0,
        onChange
      }) => {

        if (!track || !slides.length) return null;

        let index = 0;
        let frame;
        let timer;

        const dots = [];

        if (dotsWrap) {
          dotsWrap.innerHTML = '';

          slides.forEach((_, dotIndex) => {
            const dot = document.createElement('button');

            dot.type = 'button';
            dot.setAttribute('aria-label', `Mostrar item ${dotIndex + 1}`);

            if (dotIndex === 0) {
              dot.classList.add('is-active');
            }

            dotsWrap.appendChild(dot);
            dots.push(dot);
          });
        }

        const update = (newIndex) => {
          index = Math.max(0, Math.min(slides.length - 1, newIndex));

          slides.forEach((slide, slideIndex) => {
            slide.classList.toggle('is-active', slideIndex === index);
          });

          dots.forEach((dot, dotIndex) => {
            dot.classList.toggle('is-active', dotIndex === index);
          });

          if (onChange) {
            onChange(index);
          }
        };

        const goTo = (nextIndex) => {
          if (!slides.length) return;

          const wrapped =
            (nextIndex + slides.length) % slides.length;

          const slide = slides[wrapped];

          const target =
            slide.offsetLeft -
            (track.clientWidth - slide.offsetWidth) / 2;

          track.scrollTo({
            left: target,
            behavior: 'smooth'
          });

          update(wrapped);
        };

        const findNearest = () => {
          const center =
            track.scrollLeft + track.clientWidth / 2;

          let nearest = 0;
          let distance = Infinity;

          slides.forEach((slide, slideIndex) => {
            const slideCenter =
              slide.offsetLeft + slide.offsetWidth / 2;

            const nextDistance =
              Math.abs(slideCenter - center);

            if (nextDistance < distance) {
              distance = nextDistance;
              nearest = slideIndex;
            }
          });

          if (nearest !== index) {
            update(nearest);
          }
        };

        const stop = () => {
          if (timer) {
            clearInterval(timer);
            timer = null;
          }
        };

        const start = () => {
          if (!autoplay || slides.length < 2) return;

          stop();

          timer = setInterval(() => {
            goTo(index + 1);
          }, autoplay);
        };

        const restart = () => {
          stop();
          start();
        };

        track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(findNearest);
          },
          { passive: true }
        );

        prev?.addEventListener('click', () => {
          goTo(index - 1);
          restart();
        });

        next?.addEventListener('click', () => {
          goTo(index + 1);
          restart();
        });

        dots.forEach((dot, dotIndex) => {
          dot.addEventListener('click', () => {
            goTo(dotIndex);
            restart();
          });
        });

        track.addEventListener('touchstart', stop, { passive: true });
        track.addEventListener('touchend', start, { passive: true });
        track.addEventListener('mouseenter', stop);
        track.addEventListener('mouseleave', start);

        update(0);
        start();

        return {
          goTo,
          update,
          stop,
          start,
          getIndex: () => index
        };
      };


      /* ======================================================
         VÍDEOS — PLAY MANUAL + SOM
         ====================================================== */

      const videoTrack =
        root.querySelector('[data-video-track]');

      const videoSlides =
        videoTrack
          ? Array.from(
              videoTrack.querySelectorAll('[data-video-slide]')
            )
          : [];

      if (videoSlides.length <= 1) {
        root
          .querySelectorAll(
            '[data-video-prev], [data-video-next], [data-video-dots]'
          )
          .forEach((element) => {
            element.style.display = 'none';
          });
      }

      let soundEnabled = true;

      const updateSoundButtons = () => {

        videoSlides.forEach((slide) => {

          const soundButton =
            slide.querySelector('[data-video-sound]');

          const soundOn =
            soundButton?.querySelector('[data-sound-on]');

          const soundOff =
            soundButton?.querySelector('[data-sound-off]');

          if (!soundButton) return;

          if (soundOn) {
            soundOn.hidden = !soundEnabled;
          }

          if (soundOff) {
            soundOff.hidden = soundEnabled;
          }

          soundButton.setAttribute(
            'aria-label',
            soundEnabled
              ? 'Desligar som'
              : 'Ligar som'
          );
        });
      };

      const pauseAllVideos = (exceptIndex = -1) => {

        videoSlides.forEach((slide, slideIndex) => {

          const video =
            slide.querySelector('video');

          const button =
            slide.querySelector('[data-video-toggle]');

          const pauseIcon =
            button?.querySelector('[data-video-pause]');

          const playIcon =
            button?.querySelector('[data-video-play]');

          if (!video || slideIndex === exceptIndex) return;

          video.pause();

          if (pauseIcon) pauseIcon.hidden = true;
          if (playIcon) playIcon.hidden = false;

          if (button) {
            button.setAttribute(
              'aria-label',
              'Reproduzir vídeo'
            );
          }
        });
      };

      const videoCarousel =
        createSnapCarousel({
          track: videoTrack,
          slides: videoSlides,
          prev: root.querySelector('[data-video-prev]'),
          next: root.querySelector('[data-video-next]'),
          dotsWrap: root.querySelector('[data-video-dots]'),
          autoplay: 0,
          onChange: () => {
            pauseAllVideos();
          }
        });

      const playVideo = (slide, slideIndex) => {

        const video =
          slide.querySelector('video');

        const button =
          slide.querySelector('[data-video-toggle]');

        if (!video || !button) return;

        const pauseIcon =
          button.querySelector('[data-video-pause]');

        const playIcon =
          button.querySelector('[data-video-play]');

        if (!video.paused) {

          video.pause();

          if (pauseIcon) pauseIcon.hidden = true;
          if (playIcon) playIcon.hidden = false;

          button.setAttribute(
            'aria-label',
            'Reproduzir vídeo'
          );

          return;
        }

        pauseAllVideos(slideIndex);

        video.muted = !soundEnabled;
        video.volume = 1;

        const promise =
          video.play();

        if (
          promise &&
          typeof promise.then === 'function'
        ) {

          promise
            .then(() => {

              if (pauseIcon) pauseIcon.hidden = false;
              if (playIcon) playIcon.hidden = true;

              button.setAttribute(
                'aria-label',
                'Pausar vídeo'
              );
            })
            .catch(() => {

              /*
                Fallback para browsers que, por algum motivo,
                bloqueiem reprodução com som.
              */
              video.muted = true;

              const mutedPromise =
                video.play();

              if (
                mutedPromise &&
                typeof mutedPromise.then === 'function'
              ) {

                mutedPromise
                  .then(() => {

                    soundEnabled = false;
                    updateSoundButtons();

                    if (pauseIcon) pauseIcon.hidden = false;
                    if (playIcon) playIcon.hidden = true;

                    button.setAttribute(
                      'aria-label',
                      'Pausar vídeo'
                    );
                  })
                  .catch(() => {

                    if (pauseIcon) pauseIcon.hidden = true;
                    if (playIcon) playIcon.hidden = false;

                    button.setAttribute(
                      'aria-label',
                      'Reproduzir vídeo'
                    );
                  });
              }
            });
        }
      };

      const activateAndPlay =
        (slide, slideIndex) => {

          if (
            videoCarousel &&
            videoCarousel.getIndex() !== slideIndex
          ) {
            videoCarousel.goTo(slideIndex);
          }

          /*
            O play continua dentro da interação da utilizadora,
            o que é importante para o som funcionar em mobile.
          */
          playVideo(slide, slideIndex);
        };

      videoSlides.forEach((slide, slideIndex) => {

        const video =
          slide.querySelector('video');

        const playButton =
          slide.querySelector('[data-video-toggle]');

        const soundButton =
          slide.querySelector('[data-video-sound]');

        if (!video) return;

        if (playButton) {

          playButton.addEventListener(
            'click',
            (event) => {

              event.preventDefault();
              event.stopPropagation();

              activateAndPlay(
                slide,
                slideIndex
              );
            }
          );
        }

        video.addEventListener(
          'click',
          () => {

            activateAndPlay(
              slide,
              slideIndex
            );
          }
        );

        if (soundButton) {

          soundButton.addEventListener(
            'click',
            (event) => {

              event.preventDefault();
              event.stopPropagation();

              soundEnabled =
                !soundEnabled;

              videoSlides.forEach(
                (videoSlide) => {

                  const currentVideo =
                    videoSlide.querySelector('video');

                  if (currentVideo) {
                    currentVideo.muted =
                      !soundEnabled;
                  }
                }
              );

              updateSoundButtons();
            }
          );
        }
      });

      pauseAllVideos();
      updateSoundButtons();


      /* ======================================================
         DOURADO / PRATEADO
         ====================================================== */

      const setFinish = (finish) => {

        const pretty =
          finish === 'prateado'
            ? 'Prateado'
            : 'Dourado';

        root
          .querySelectorAll('[data-finish]')
          .forEach((button) => {
            button.setAttribute(
              'aria-pressed',
              String(
                normalize(button.dataset.finish || '') === finish
              )
            );
          });

        root
          .querySelectorAll('[data-selected-finish]')
          .forEach((element) => {
            element.textContent = pretty;
          });

        root
          .querySelectorAll('[data-product-card]')
          .forEach((card) => {

            const variants =
              Array.from(
                card.querySelectorAll('[data-variant-title]')
              );

            const match =
              variants.find((input) => {
                return (
                  normalize(input.dataset.variantTitle || '')
                    .includes(finish)
                  &&
                  !input.disabled
                );
              });

            if (match) {
              match.checked = true;
              match.dispatchEvent(
                new Event('change', { bubbles: true })
              );
            }
          });
      };

      root
        .querySelectorAll('[data-finish]')
        .forEach((button) => {
          button.addEventListener('click', () => {
            setFinish(
              normalize(button.dataset.finish || '')
            );
          });
        });

      setFinish('dourado');


      /* ======================================================
         DOTS DOS PRODUTOS NO MOBILE
         ====================================================== */

      const productTrack =
        root.querySelector('[data-product-track]');

      const productCards =
        productTrack
          ? Array.from(
              productTrack.querySelectorAll('[data-product-card]')
            )
          : [];

      const productDots =
        Array.from(
          root.querySelectorAll('[data-product-dots] span')
        );

      if (productTrack && productCards.length) {

        let productFrame;

        productTrack.addEventListener(
          'scroll',
          () => {

            cancelAnimationFrame(productFrame);

            productFrame =
              requestAnimationFrame(() => {

                const center =
                  productTrack.scrollLeft +
                  productTrack.clientWidth / 2;

                let nearest = 0;
                let distance = Infinity;

                productCards.forEach((card, cardIndex) => {

                  const cardCenter =
                    card.offsetLeft +
                    card.offsetWidth / 2;

                  const nextDistance =
                    Math.abs(cardCenter - center);

                  if (nextDistance < distance) {
                    distance = nextDistance;
                    nearest = cardIndex;
                  }
                });

                productDots.forEach((dot, dotIndex) => {
                  dot.classList.toggle(
                    'is-active',
                    dotIndex === nearest
                  );
                });
              });
          },
          { passive: true }
        );
      }


      /* ======================================================
         ADD TO CART AJAX
         ====================================================== */

      const toast =
        root.querySelector('[data-toast]');

      let toastTimer;

      const showToast = (message) => {

        if (!toast) return;

        const text =
          toast.querySelector('[data-toast-text]');

        if (text) {
          text.textContent = message;
        }

        toast.hidden = false;

        clearTimeout(toastTimer);

        toastTimer =
          setTimeout(() => {
            toast.hidden = true;
          }, 3800);
      };

      root
        .querySelectorAll('[data-product-form]')
        .forEach((form) => {

          form.addEventListener(
            'submit',
            async (event) => {

              event.preventDefault();

              const button =
                form.querySelector('[data-add-button]');

              if (!button || button.disabled) return;

              const original =
                button.innerHTML;

              button.disabled = true;
              button.innerHTML =
                '<span>A adicionar…</span>';

              try {

                const base =
                  window.Shopify &&
                  window.Shopify.routes
                    ? window.Shopify.routes.root
                    : '/';

                const response =
                  await fetch(
                    `${base}cart/add.js`,
                    {
                      method: 'POST',
                      headers: {
                        Accept: 'application/json',
                        'X-Requested-With':
                          'XMLHttpRequest'
                      },
                      body: new FormData(form)
                    }
                  );

                if (!response.ok) {
                  throw new Error('cart');
                }

                const cartResponse =
                  await fetch(
                    `${base}cart.js`,
                    {
                      headers: {
                        Accept:
                          'application/json'
                      }
                    }
                  );

                const cart =
                  cartResponse.ok
                    ? await cartResponse.json()
                    : null;

                if (cart) {

                  document
                    .querySelectorAll(
                      '[data-cart-count], .aurora-cart-count'
                    )
                    .forEach((count) => {

                      count.textContent =
                        cart.item_count;

                      count.removeAttribute('hidden');
                    });

                  document.dispatchEvent(
                    new CustomEvent(
                      'cart:refresh',
                      {
                        detail: { cart }
                      }
                    )
                  );
                }

                button.innerHTML =
                  '<span>É tua ♡</span><span>✓</span>';

                showToast(root.dataset.success);

              } catch (error) {

                button.innerHTML =
                  '<span>Tentar novamente</span>';

                showToast(root.dataset.error);

              } finally {

                setTimeout(() => {
                  button.innerHTML = original;
                  button.disabled = false;
                }, 1800);
              }
            }
          );
        });


      /* ======================================================
         REVIEWS — AUTO 5.2S + SETAS + SWIPE
         ====================================================== */

      const reviewTrack =
        root.querySelector('[data-review-track]');

      const reviewSlides =
        reviewTrack
          ? Array.from(
              reviewTrack.querySelectorAll('[data-review-slide]')
            )
          : [];

      createSnapCarousel({
        track: reviewTrack,
        slides: reviewSlides,
        prev: root.querySelector('[data-review-prev]'),
        next: root.querySelector('[data-review-next]'),
        dotsWrap: root.querySelector('[data-review-dots]'),
        autoplay: 5200
      });


      /* ======================================================
         FAQ — SÓ UMA ABERTA
         ====================================================== */

      const faqItems =
        Array.from(
          root.querySelectorAll('.am-faq details')
        );

      faqItems.forEach((item) => {
        item.addEventListener('toggle', () => {

          if (!item.open) return;

          faqItems.forEach((other) => {
            if (other !== item) {
              other.open = false;
            }
          });
        });
      });


      /* ======================================================
         STICKY MOBILE — discreto e só antes da zona de compra
         ====================================================== */

      const buy =
        root.querySelector('.am-buy');

      const sticky =
        root.querySelector('[data-sticky]');

      if (buy && sticky) {

        let stickyFrame;

        const updateSticky = () => {

          cancelAnimationFrame(stickyFrame);

          stickyFrame =
            requestAnimationFrame(() => {

              const isDesktop =
                window.matchMedia('(min-width: 750px)').matches;

              if (isDesktop) {
                sticky.classList.add('is-hidden');
                return;
              }

              const buyRect =
                buy.getBoundingClientRect();

              const hasLeftHero =
                window.scrollY > 240;

              const buyIsStillAhead =
                buyRect.top > window.innerHeight * .32;

              sticky.classList.toggle(
                'is-hidden',
                !hasLeftHero || !buyIsStillAhead
              );
            });
        };

        window.addEventListener(
          'scroll',
          updateSticky,
          { passive: true }
        );

        window.addEventListener(
          'resize',
          updateSticky,
          { passive: true }
        );

        updateSticky();
      }

    });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
